import { type Plugin } from 'chart.js'

/**
 * Marks a body-appended external-tooltip element for orphan cleanup. Every
 * tooltip factory stamps this on the element it creates; removeOrphanTooltipEls
 * finds them by it. Kept in one place so the write and the query can't drift.
 */
export const CHART_TOOLTIP_ATTR = 'data-chart-tooltip'

/**
 * Removes every external-tooltip element from document.body. The tooltip
 * handlers only hide their element on Chart.js mouse-out, so a chart destroyed
 * by navigation would otherwise leave its tooltip visible on the next page.
 * Safe to run on any chart's destroy: an already-removed element is a no-op, and
 * a live chart re-creates its element on the next hover.
 */
export function removeOrphanTooltipEls(): void {
  document.querySelectorAll(`[${CHART_TOOLTIP_ATTR}]`).forEach((el) => {
    el.remove()
  })
}

/**
 * Globally registered (see main.ts) so it fires for every chart instance —
 * including the OwnLineChart / OwnBarChart wrappers that don't forward a
 * per-chart `plugins` prop.
 */
export const removeOrphanTooltipsPlugin: Plugin = {
  afterDestroy: removeOrphanTooltipEls,
  id: 'removeOrphanTooltips',
}
